var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.737 1.964c.4.042.7.303.848.611.162.34.162.774-.066 1.137V3.71a5.638 5.638 0 0 0 7.77 7.77l.139-.075c.33-.15.698-.134.997.008.308.147.568.448.61.848l.006.176a9.958 9.958 0 1 1-10.48-10.48zm-.293 1.206a8.757 8.757 0 1 0 9.385 9.385 6.84 6.84 0 0 1-8.363-1.02 6.84 6.84 0 0 1-1.022-8.365"
  })));
};
export default SvgMoon;